<template>
  <div class="data-manage">
    <star-condition-layout
      :onSearch="handleSearch"
      :onReset="reset"
      :loading="loading"
      ref="condition"
    >
      <star-condition-cell label="敏感词">
        <a-input v-model="search.word" placeholder="请输入敏感词" />
      </star-condition-cell>
    </star-condition-layout>

    <div class="table-wrap">
      <TableHeadIcons :onRefresh="getTableList" :size.sync="tableDensity" :columns="columns">
        <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button>
      </TableHeadIcons>

      <a-table
        :loading="loading"
        :size="tableDensity"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="userId"
        :columns="showColumns"
        :dataSource="dataSource"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="status" slot-scope="text, record">{{
          record.status == '-1' ? '停用' : '启用 '
        }}</span>
        <span slot="createTime" slot-scope="text, record">{{
          record.createTime | formateTime
        }}</span>
        <div slot="action" slot-scope="text, record">
          <a href="javascript:;" @click="handleEdit(record)"> <a-icon type="edit" /> 修改 </a>
          <a-divider type="vertical" />

          <a-popconfirm title="确定要删除吗?" @confirm="() => handleDelete(record)">
            <a href="javascript:;"> <a-icon type="delete" />删除 </a>
          </a-popconfirm>
        </div>
      </a-table>
    </div>

    <a-drawer
      :title="formModel == null ? '新增敏感词' : '修改敏感词'"
      width="600"
      :closable="true"
      :visible="visible"
      @close="visible = false"
    >
      <Form ref="form" v-if="visible" @refresh="handleRefresh" :formModel="formModel" />
    </a-drawer>
  </div>
</template>

<script>
import { getSensitiveListApi, deleteSensitiveApi } from '@/api/System/Sensitive'
// import moment from 'moment'
import Form from './Form.vue'
export default {
  data() {
    return {
      tableDensity: 'middle',
      loading: false,
      visible: false,
      search: {
        word: undefined
      },
      columns: [
        {
          width: 60,
          align: 'center',
          title: '序号',
          show: true,
          scopedSlots: { customRender: 'index' }
        },
        {
          dataIndex: 'id',
          align: 'center',
          title: 'Id',
          show: false
        },
        {
          title: '敏感词',
          ellipsis: true,
          show: true,
          dataIndex: 'word'
        },
        {
          title: '创建时间',
          ellipsis: true,
          show: true,
          dataIndex: 'createTime'
        },
        {
          title: '更新时间',
          ellipsis: true,
          show: true,
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          width: 260,
          show: true,
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      sorter: {},
      formModel: null
    }
  },
  created() {
    this.getTableList()
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  methods: {
    reset() {
      this.search.word = undefined
      this.getTableList()
    },
    handleAdd() {
      this.formModel = null
      this.visible = true
    },

    handleEdit(record) {
      this.formModel = record
      this.visible = true
    },

    handleSearch() {
      this.pagination.current = 1
      this.getTableList()
    },

    handleRefresh() {
      this.pagination.current = 1
      this.visible = false
      this.getTableList()
    },

    handleReset() {
      this.search.word = ''
      this.handleSearch()
    },

    //根据id删除数据
    async handleDelete(record) {
      const res = await deleteSensitiveApi(record.id)
      const { code, msg } = res
      if (code == '200') {
        this.getTableList()
        this.$message.success(msg)
      } else {
        this.$message.error(msg)
      }
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination
      if (sorter.order) {
        this.sorter = {
          orderKey: sorter.field,
          isAsc: sorter.order == 'ascend' ? true : false
        }
      } else {
        this.sorter = {}
      }
      this.getTableList()
    },

    async getTableList() {
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.search
      }
      this.loading = true
      let res = await getSensitiveListApi(query)
      this.loading = false
      let { code, msg, data, extra } = res
      if (code == '200') {
        this.dataSource = data.map((item) => {
          return {
            ...item,
            role: item.userRoles ? this.returnRoles(item.userRoles) : null
          }
        })
        this.pagination.total = extra.page.pageCount || 0
      } else {
        this.$message.error(msg)
      }
    },
    returnRoles(data) {
      let a = []
      data.forEach((element) => {
        a.push(element.userRoleName)
      })
      return a.toString()
    }
  },
  components: {
    Form
  }
}
</script>

<style lang="less" scoped>
.data-manage {
  padding: 16px;
  .search {
    padding: 20px 20px 0 20px;
    background: #fff;
    margin-bottom: 20px;
  }
  .table-wrap {
    margin-top: 16px;
    background: #fff;
    padding: 0 20px 0 20px;
  }
}
</style>
